var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgAccount = function SvgAccount(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    viewBox: "0 0 17.7 20.2",
    style: {
      enableBackground: "new 0 0 17.7 20.2"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M13.1,9.2c0.8-1,1.3-2.3,1.3-3.6C14.3,2.5,11.9,0,9,0L8.8,0L8.7,0C5.8,0,3.4,2.5,3.4,5.6c0,1.3,0.4,2.6,1.3,3.6 C1.9,10.7,0,13.6,0,16.4c0,0.7,0.2,2.8,3,3.5c0.9,0.2,2.1,0.3,3.4,0.3l2.4,0l2.4,0c1.4,0,2.5,0,3.4-0.3c2.8-0.7,3-2.9,3-3.5 C17.7,13.6,15.8,10.7,13.1,9.2z M14.4,18.8C13.6,19,12.6,19,11.3,19l-2.4,0l-2.4,0c-1.3,0-2.3,0-3.2-0.2c-1.8-0.4-2.1-1.7-2.1-2.4 c0-2.6,2-5.3,4.7-6.5l0.9-0.4L6.1,8.9C5.1,8.1,4.6,6.9,4.6,5.6c0-2.4,1.8-4.4,4.1-4.4l0.1,0l0.2,0c2.2,0,4.1,2,4.1,4.4 c0,1.3-0.5,2.5-1.5,3.4l-0.7,0.6l0.9,0.4c2.7,1.1,4.7,3.8,4.7,6.5C16.5,17.1,16.2,18.3,14.4,18.8z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAccount, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/account.053dbca3.svg";
export { ForwardRef as ReactComponent };